import clsx from 'clsx';
import React, { useState } from 'react';
import { getColorClassName } from '../../objects/facets/Color';
import { has, is } from '../../services/classify';
import { Icon } from '../icon';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Tag Component
 * @param children {ReactNode} Add childrens for tag
 * @param variant {TagVariant} Available tag variants
 * @param deletable {boolean} Adding delete icon
 * @param inverted {boolean} Inverted tag
 * @param onClick {Function} OnClick Event
 * @param className {string} Additionnal CSS Classes
 **/
const Tag = ({ children, className, variant, deletable, onClick, inverted, small, iconName, testId, ...others }) => {
    const [display, setDisplay] = useState(deletable || false);
    const { styled } = useTrilogyContext();
    const tagClassNames = hashClass(styled, clsx('tag', !deletable && variant && is(getColorClassName(variant)), !deletable && inverted && is('inverted'), small && is('small'), !deletable && className, deletable && !display && is('hidden')));
    const tagIconClassNames = hashClass(styled, clsx(variant && is(getColorClassName(variant))));
    const onClickHandle = (e) => {
        setDisplay(false);
        if (onClick) {
            onClick(e);
        }
    };
    const deleteClasses = hashClass(styled, clsx('tags', variant && is(getColorClassName(variant)), deletable && [has('addons'), is('delete')], inverted && is('inverted'), small && is('small'), className));
    // Deletable tag
    if (deletable && display) {
        return (React.createElement("div", { "data-testid": testId, className: deleteClasses },
            React.createElement("span", { className: tagClassNames }, children),
            React.createElement("a", { "data-testid": `${testId}_close_button`, onClick: onClickHandle, className: tagClassNames })));
    }
    // Default tag
    return (React.createElement("span", { "data-testid": testId, onClick: onClick && onClick, className: tagClassNames, ...others },
        iconName && React.createElement(Icon, { className: tagIconClassNames, name: iconName }),
        children));
};
export default Tag;
//# sourceMappingURL=Tag.js.map